import { render, staticRenderFns } from "./SupplementRate.vue?vue&type=template&id=01c20089&scoped=true"
import script from "./SupplementRate.vue?vue&type=script&lang=js"
export * from "./SupplementRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c20089",
  null
  
)

export default component.exports